import { render } from "./FamousLoader.vue?vue&type=template&id=3c274fcc"
import script from "./FamousLoader.vue?vue&type=script&lang=js"
export * from "./FamousLoader.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__